import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import Header from "../../components/Header";
import { getFeeScheduleForMedicationById } from "./../../ApiConfig.jsx";

function ViewFeeScheduleForMedication() {
  const { id } = useParams();
  const [itemDetails, setItemDetails] = useState({});
  const fetchData = async (id) => {
    try {
      const data = await getFeeScheduleForMedicationById(id);
      if (data.status==="OK") {
        console.log(data.data);
        setItemDetails({
          Medication: data.data.medication,
          Pharmacy: data.data.pharmacy,
          "Drug category": data.data.drugCategory,
          Covered: data.data.isCovered ? "Yes" : "No",
          "Posted date": new Date(data.data.createdAt)
            .toISOString()
            .split("T")[0],
          Fee: data.data.price,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`View Fee Schedule For Medication ${id}`} subtitle="" />
      <Box ml={"40px"}>
        <Grid container spacing={2}>
          {Object.entries(itemDetails).map(([field, value]) => (
            <React.Fragment key={field}>
              <Grid item xs={3}>
                <Typography variant="h5" component="span" fontWeight="bold">
                  {field}:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>{value}</Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default ViewFeeScheduleForMedication;
